import { render } from "./TracedPension.vue?vue&type=template&id=6163fe0a&scoped=true"
import script from "./TracedPension.vue?vue&type=script&lang=js"
export * from "./TracedPension.vue?vue&type=script&lang=js"

import "./TracedPension.vue?vue&type=style&index=0&id=6163fe0a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6163fe0a"]])

export default __exports__